import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/layout/index'

Vue.use(Router)
export const constantRoutes = [
    {
        path: '/',
        name: 'Home',
        component: Layout,
        redirect: '/dashbord',
        children: [
            {
                path: 'dashbord',
                name: 'Dashbord',
                component: () => import('@/views/dashbord'),
                meta: {title: '首页', icon: 'el-icon-s-home'}
            }
        ]
    },
    {
        path: '/menu/nextMenu',
        component: Layout,
        hidden: true,
        redirect: 'menu/nextMenu',
        children: [{
            path: '/menu/nextMenu/:id',
            component: () => import('@/views/system/menu/nextMenu'),
            name: '菜单管理',
            meta: {title: '菜单管理', icon: 'table'},

        }]
    },
    {
        path: '/menu/threeMenu',
        component: Layout,
        hidden: true,
        redirect: 'menu/threeMenu',
        children: [{
            path: '/menu/threeMenu/:id',
            component: () => import('@/views/system/menu/threeMenu'),
            name: '菜单管理',
            meta: {title: '菜单管理', icon: 'table'},

        }]
    },
    {
        path: '/login',
        name: 'Login',
        component: () => import('@/views/login'),
        meta: {title: '登录页'},
        hidden: true
    },
    {
        path: '/user',
        name: 'userCenter',
        component: Layout,
        redirect: '/userCenter',
        hidden: true,
        children: [
            {
                path: '/userCenter',
                name: 'userCenter',
                component: () => import('@/views/user/userCenter'),
                meta: {title: '我的账户'}
            }
        ]
    },
    {
        path: '/changePassword',
        name: 'changePassword',
        component: Layout,
        redirect: '/changePassword',
        hidden: true,
        children: [
            {
                path: '/changePassword',
                name: 'changePassword',
                component: () => import('@/views/user/changePassword'),
                meta: {title: '修改密码'}
            }
        ]
    },

]

/*export const currencyRoutes = [
    {
        path: '/login',
        name: 'Login',
        component: () => import('@/views/login'),
        meta: {title: '登录页'},
        hidden: true
    },
    {
        path: '/user',
        name: 'userCenter',
        component: Layout,
        redirect: '/userCenter',
        hidden: true,
        children: [
            {
                path: '/userCenter',
                name: 'userCenter',
                component: () => import('@/views/user/userCenter'),
                meta: {title: '我的账户'}
            }
        ]
    },
    {
        path: '/',
        name: 'Home',
        component: Layout,
        redirect: '/dashbord',
        children: [
            {
                path: 'dashbord',
                name: 'Dashbord',
                component: () => import('@/views/dashbord'),
                meta: {title: '首页', icon: 'el-icon-s-home'}
            }
        ]
    },
    {
        path: '/permission',
        name: 'Permission',
        component: Layout,
        redirect: '/permission/roles',
        meta: {
            title: '系统管理',
            icon: 'el-icon-s-tools',
            iconKey: 'menu-sys'
        },
        children: [
            {
                path: 'roles',
                name: 'Roles',
                component: () => import('@/views/permission/roles'),
                meta: {title: '用户管理', icon: 'el-icon-user', iconKey: 'menu-user'}
            },
            {
                path: 'journal',
                name: 'journal',
                component: () => import('@/views/journal/index'),
                meta: {title: '日志管理', icon: 'el-icon-video-camera', iconKey: 'menu-journal'}
            }
        ]
    },
    {
        path: '/report',
        name: 'Report',
        component: Layout,
        redirect: '/report/',
        meta: {
            title: '信用报告管理',
            icon: 'el-icon-s-finance',
            iconKey: 'menu-report'
        },
        children: [
            {
                path: 'generation',
                name: 'Reneration',
                component: () => import('@/views/report/reportGeneration.vue'),
                meta: {title: '模板报告管理', icon: 'el-icon-tickets', iconKey: 'menu-report-generation'}
            },
            {
                path: 'custom',
                name: 'Custom',
                component: () => import('@/views/report/reportCustom.vue'),
                meta: {title: '定制报告管理', icon: 'el-icon-document', iconKey: 'menu-report-custom'}
            }
        ]
    },
    {
        path: '/history',
        name: 'History',
        component: Layout,
        redirect: '/history',
        children: [
            {
                path: 'reportHistory',
                name: 'reportHistory',
                component: () => import('@/views/report/reportHistory.vue'),
                meta: {title: '报告动态监测', icon: 'el-icon-s-data', iconKey: 'menu-report-history'}
            }
        ]
    },
]*/

const createRouter = () => new Router({
    // mode: 'history', // require service support
    scrollBehavior: () => ({y: 0}),
    routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
    const newRouter = createRouter()
    router.matcher = newRouter.matcher // reset router
}

export default router


/*
const router = new Router({
    routes: currencyRoutes
})
// 全局路由守卫
router.beforeEach((to, from, next) => {
    let isLogin = sessionStorage.getItem('store')?JSON.parse(sessionStorage.getItem('store')).isLogin:null
    if(to.path === '/login'){
        next();
    }else{
        if(!isLogin){
            next('/login');
        }
    }
    next()
})

export default router*/





// WEBPACK FOOTER //
// ./src/router/index.js